module.exports = __webpack_public_path__ + "img/35.60be9812.png";